let isDirty = false;

export function setDirtyFlag(value) {
  isDirty = value;
}

export function safeNavigate(navigateFn, to) {
  if (isDirty) {
    const ok = window.confirm('Recording is in progress. Leave anyway?');
    if (!ok) return;
  }
  navigateFn(to);
}
